import type { CategoryKind } from '@budgetx/shared';

export function detectKindFromFilename(name: string): CategoryKind {
  const lower = name.toLowerCase();
  if (lower.startsWith('indtaegter')) return 'income';
  if (lower.startsWith('variable-udgifter') || lower.startsWith('variabel')) return 'variabel';
  // Default: fast (matches existing exports + backward compat)
  return 'fast';
}
